import { NgModule } from '@angular/core';
import { S101gS101m01Component } from './s101g-s101m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S101gS101m01Component]
})
export class S101gModule { }

